
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/milliy-sertifikat",
      function () {
        return require("private-next-pages/milliy-sertifikat/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/milliy-sertifikat"])
      });
    }
  